/**
 * Product card image galleries.
 *
 * Flips between a card's images in place so a shopper can look through them
 * without opening the product. Images are stacked in one frame and swapped by
 * opacity, so there is no layout shift and no scrolling.
 *
 * The arrows are aria-hidden from the tab order on purpose: every image links
 * to the same product page, so tabbing through two extra buttons per card adds
 * noise for keyboard users without giving them anything new. The product page
 * gallery is the accessible route to the full set.
 */
(() => {
  const show = (frame, index) => {
    const imgs = frame.querySelectorAll('.mdc-card-media__img');
    if (imgs.length < 2) return;

    const next = (index + imgs.length) % imgs.length;
    imgs.forEach((img, i) => img.toggleAttribute('data-active', i === next));
    frame.dataset.index = String(next);

    const count = frame.querySelector('[data-mdc-card-count]');
    if (count) count.textContent = `${next + 1}/${imgs.length}`;
  };

  const init = (root = document) => {
    root.querySelectorAll('[data-mdc-card-gallery]').forEach((frame) => {
      if (frame.dataset.galleryReady) return;
      frame.dataset.galleryReady = 'true';

      show(frame, 0);

      const move = (delta) => (event) => {
        event.preventDefault();
        event.stopPropagation();
        show(frame, Number(frame.dataset.index || 0) + delta);
      };

      frame.querySelector('[data-mdc-card-prev]')?.addEventListener('click', move(-1));
      frame.querySelector('[data-mdc-card-next]')?.addEventListener('click', move(1));
    });
  };

  document.addEventListener('shopify:section:load', (event) => init(event.target));
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }
})();
